import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const CartContext = createContext(null);

const SESSION_KEY = "welljio_session_id";

function getSessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = "wj_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export function CartProvider({ children }) {
  const [sessionId] = useState(getSessionId);
  const [cart, setCart] = useState({ items: [], subtotal: 0, shipping: 0, total: 0 });
  const [loading, setLoading] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get(`/cart/${sessionId}`);
      setCart(data);
    } catch (e) {
      console.error("cart refresh failed", e);
    }
  }, [sessionId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const addItem = async (product_id, quantity = 1) => {
    setLoading(true);
    try {
      const current = cart.items.find((i) => i.product.id === product_id);
      const next = (current?.quantity || 0) + quantity;
      const { data } = await api.post(`/cart/update`, { session_id: sessionId, product_id, quantity: next });
      setCart(data);
      setCartOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const setQuantity = async (product_id, quantity) => {
    const { data } = await api.post(`/cart/update`, { session_id: sessionId, product_id, quantity });
    setCart(data);
  };

  const removeItem = async (product_id) => {
    const { data } = await api.post(`/cart/remove`, { session_id: sessionId, product_id });
    setCart(data);
  };

  const clearCart = async () => {
    const { data } = await api.delete(`/cart/${sessionId}`);
    setCart(data);
  };

  const count = cart.items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider
      value={{
        sessionId,
        cart,
        loading,
        cartOpen,
        setCartOpen,
        addItem,
        setQuantity,
        removeItem,
        clearCart,
        refresh,
        count,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
